<template functional>
    <div class="o-movie-description-block">
        <span class="movie-description-block-label">
            {{ props.label }}
        </span>
        <span class="movie-description-block-text">
            {{ props.text }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'OMovieDescriptionBlock',
    props: {
        label: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />